import { render, staticRenderFns } from "./SimpleEvent.vue?vue&type=template&id=4f4ed24e&scoped=true&"
import script from "./SimpleEvent.vue?vue&type=script&lang=js&"
export * from "./SimpleEvent.vue?vue&type=script&lang=js&"
import style0 from "./SimpleEvent.vue?vue&type=style&index=0&id=4f4ed24e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ed24e",
  null
  
)

export default component.exports